import styled from 'styled-components';

export const ResizeCellContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: var(--allie-color-error-main);
  margin-bottom: 3px;
  box-shadow: 0 0 0 3px black;
  position: absolute;
`;

export const ResizeCellControl = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  color: white;
  font-size: 24px;
  position: relative;

  ion-icon {
    width: 14px;
    height: 14px;
  }

  .allie-resizable-box__control__pointer {
    cursor: ew-resize;
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;
